<div class="pdf-viewer-container">
  @if (pdfUrl()) {
    <div class="viewer-wrapper">
      @if (!isLoaded()) {
        <div
          class="pdf-viewer-loader loading-container"
          aria-busy="true"
          [attr.aria-label]="'learningPathway.PDF_LOADING' | transloco"
        >
          <qai-loading [size]="'medium'"></qai-loading>
        </div>
      }
      <div class="viewer-area" #centerRef>
        <pdf-viewer
          [src]="pdfUrl()"
          (pagesLoaded)="onPagesLoaded($event)"
          (pageChange)="onPageChange($event)"
          (pageRendered)="onPageRendered()"
          (beyondPageWidth)="onBeyondPageWidth($event)"
          (isScrollable)="onIsScrollable($event)"
          (scrolledToBottom)="onScrolledToBottom($event)"
        />
        @if (!isZoomedBeyondPageWidth()) {
          <qai-page-indicator
            #pageIndicatorRef
            class="page-indicator"
            [class.visible]="hasPageRendered()"
            [currentPage]="currentPage()"
            [totalPages]="totalPages() || 0"
            aria-live="polite"
          />
        }
      </div>
      @if (showScrollHint) {
        <div class="scroll-hint" aria-live="polite">
          {{ 'learningPathway.PDF_SCROLL_HINT' | transloco }}
        </div>
      }
      @if (!isZoomedBeyondPageWidth()) {
        <button
          qai-button
          type="button"
          [shape]="'circle'"
          [kind]="'tertiary'"
          [size]="'small'"
          [disabled]="!canGoPrevious"
          (click)="previousPage()"
          class="nav-button nav-left"
          [attr.aria-label]="'learningPathway.PDF_PREVIOUS_PAGE' | transloco"
        >
          <qai-icon kind="chevron-left" positionStart />
        </button>
        <button
          qai-button
          type="button"
          [shape]="'circle'"
          [kind]="'tertiary'"
          [size]="'small'"
          [disabled]="!canGoNext"
          (click)="nextPage()"
          class="nav-button nav-right"
          [attr.aria-label]="'learningPathway.PDF_NEXT_PAGE' | transloco"
        >
          <qai-icon kind="chevron-right" positionStart />
        </button>
      }
    </div>
  } @else {
    <div class="pdf-viewer-empty">
      <p>{{ "learningPathway.PDF_NO_SOURCE" | transloco }}</p>
    </div>
  }
</div>
